import React, { useState, useCallback } from "react"

// Redux
import { login } from "../redux/actions"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { PageTitle, FormTitle, Button, TextLink } from "./../components/atoms"
import {
  FieldWrapper,
  InputText,
  InputCheckboxRadio,
} from "./../components/forms"
import { _buildFormData, _makeId } from "../utils/helper"
import api from "../utils/api"
import { toast } from "react-toastify"
import { loading } from "../redux/actions"
import _ from "lodash"

const Register = (props) => {
  const [values, setValues] = useState({
    company: "",
    name: "",
    email: "",
    roles: [],
    note: "",
  })
  const [showThankYou, setShowThankYou] = useState(false)

  const [errors, setErrors] = useState({})

  const rolesOptions = [
    { value: "advertiser", label: "Advertiser" },
    { value: "carrier", label: "Carrier" },
  ]

  const _register = useCallback(
    (values) => {
      console.log("_createUser values", values)
      let formData = new FormData()
      _buildFormData(formData, values)

      props.loading(true)

      const url = "request-account"

      api
        .post(url, formData)
        .then((result) => {
          toast.success("Registration successful!")
          // console.log("_createUser API result", result)
          setShowThankYou(true)
        })
        .catch((error) => {
          console.log("_register API error", error.data.errors)
          setErrors(error.data.errors)
        })
    },
    [props]
  )

  return (
    <div>
      <div className="bg-white py-10 pb-32 lg:pb-52 mm-motif motif-br">
        {!!showThankYou ? (
          <div className="block-640">
            <div className="pt-20 flex flex-col items-center">
              <PageTitle>Thank you</PageTitle>
              <div className="pb-10">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam.
              </div>
            </div>
          </div>
        ) : (
          <div className="block-640">
            <FormTitle>Request an account</FormTitle>

            <FieldWrapper>
              <InputText
                label="Company"
                name="company"
                type="text"
                placeholder="Enter company name"
                onChange={(e) => {
                  setValues({ ...values, company: e.target.value })
                }}
                error={_.get(errors, "company[0]")}
              />
            </FieldWrapper>

            <FieldWrapper>
              <InputText
                label="Name"
                name="name"
                type="text"
                placeholder="Enter name"
                onChange={(e) => {
                  setValues({ ...values, name: e.target.value })
                }}
                error={_.get(errors, "name[0]")}
              />
            </FieldWrapper>

            <FieldWrapper>
              <InputText
                label="Email address"
                name="email"
                type="email"
                placeholder="Enter email address"
                onChange={(e) => {
                  setValues({ ...values, email: e.target.value })
                }}
                error={_.get(errors, "email[0]")}
              />
            </FieldWrapper>

            <FieldWrapper>
              <InputCheckboxRadio
                type="checkbox"
                label="Role"
                name={_makeId(15)}
                options={rolesOptions}
                value={values.roles}
                onChange={(value) => {
                  setValues({
                    ...values,
                    roles: value,
                  })
                }}
                inline
                css="w-1/2 sm:w-4/12 md:w-3/12 mr-0"
                error={_.get(errors, "roles[0]")}
              />
            </FieldWrapper>

            <FieldWrapper>
              <InputText
                label="Note"
                name="note"
                type="textarea"
                placeholder="Enter note"
                onChange={(e) => {
                  setValues({ ...values, note: e.target.value })
                }}
                error={_.get(errors, "note[0]")}
              />
            </FieldWrapper>

            <div className="flex flex-col md:flex-row justify-between items-center mb-10">
              <Button css="mb-4 md:mb-0" onClick={() => _register(values)}>
                Request an account
              </Button>
              <TextLink
                onClick={() => {
                  props.history.push("/")
                }}
              >
                Already have an account? Log in here
              </TextLink>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    userLogin: state.Auth.userLogin,
    access_token: state.Auth.access_token,
    role: state.Auth.role,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    login: (params) => dispatch(login(params)),
    loading: (param) => dispatch(loading(param)),
  }
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Register)
)
